import api from './api';

const BASE_PATH = '/admin/trilha_generations';

/**
 * Cliente da API de gerações de trilha via IA (TrilhaGeneration).
 * Backend em backend/app/controllers/api/v1/admin/trilha_generations_controller.rb.
 */
export const trilhaGenerationsApi = {
  index: () => api.get(BASE_PATH),
  show: id => api.get(`${BASE_PATH}/${id}`),

  // Etapas da matriz SAEB: total de descritores, quantos já têm conteúdo
  // e a trilha existente da etapa (ou null).
  etapas: () => api.get(`${BASE_PATH}/etapas`),

  // body: { password, etapa, blocks_count, learning_path_name }
  create: payload => api.post(BASE_PATH, payload)
};

export default trilhaGenerationsApi;
